import "./login.css";
import ThemeContext from "context/ThemeContext";
import {useState, useContext} from "react";
import {useTranslation} from "react-i18next";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import axios from "axios";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const apiUrl = process.env?.REACT_APP_API_URL || "";
const urlStatic = process.env?.REACT_APP_STATIC_URL || "/static";
const Recovery = () => {
    //console.log("in login");
    const {t: tA} = useTranslation("authenticate");
    const {t: tC} = useCustomTranslation(translations);
    const {theme} = useContext(ThemeContext);
    const [buttonState, setButtonState] = useState(false);
    const [buttonContent, setButtonContent] = useState(tA("buttons.send-email"));
    const [activeError, setActiveError] = useState(false);
    const [messageEmail, setMessageEmail] = useState(false);

    const now = new Date();
    const spinButton = <FontAwesomeIcon icon="circle-notch" className="fa-spin" />;
    const textButton = tA("buttons.signin");

    document.body.style.height = "100%";
    const handleSubmit = (e) => {
        e.preventDefault();

        setButtonState(true);
        setButtonContent(spinButton);

        axios
            .post(apiUrl + "/api/recovery/", {
                email: e.target.email.value,
                domain: window.location.origin,
            })
            .then((res) => {
                if (res.data.status) {
                    setMessageEmail(true);
                }
            })
            .catch((error) => {
                setActiveError(true);
                setButtonState(false);
                setButtonContent(textButton);
            });
    };

    return (
        <div className="form-recovery w-100 m-auto">
            <form onSubmit={handleSubmit}>
                <div className="col-12 text-center">
                    <img
                        src={theme.logoLogin || urlStatic + "/images/quamtra_manager-black.svg"}
                        style={{width: "90%"}}
                        alt={"logo login"}
                    />
                </div>
                <h1 className="h4 mb-3 mt-4 fw-normal text-center">{tA("labels.recovery")}</h1>

                {messageEmail ? (
                    <p className="bg-success p-2 text-light text-center h5 mt-5">{tC("confirmedsendemail")}</p>
                ) : (
                    <> </>
                )}

                {!messageEmail ? <p className="h5 mb-2 text-center mb-4">{tA("title.recovery")}</p> : <> </>}

                <p className={`error-message bg-danger text-light ${activeError ? "" : "d-none"}`}>{tC("errorserver")}</p>

                {!messageEmail ? (
                    <>
                        <div className="input-group input-group-sm has-validation">
                            <span className="input-group-text bg-transparent" id="email-addon">
                                @
                            </span>
                            <div className="form-floating">
                                <input
                                    type="email"
                                    className="form-control"
                                    name="email"
                                    required
                                    id="email"
                                    placeholder="name@example.com"
                                />
                                <label htmlFor="email">{tA("labels.email")}</label>
                            </div>
                        </div>

                        <button className="btn btn-primary w-100 py-2 mt-4" type="submit" disabled={buttonState}>
                            {buttonContent}
                        </button>
                    </>
                ) : (
                    <> </>
                )}
                <a href="/login/" className="text-center w-100 d-inline-block py-2 mt-3">
                    {tA("buttons.return")}
                </a>

                <p className="mt-4 mb-3 text-body-secondary text-center">&copy;{now.getFullYear()}</p>
            </form>
        </div>
    );
};
export default Recovery;
